import { Link } from 'react-router-dom';
import { Scale, X } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { clearComparison, MAX_COMPARISON_LISTINGS } from '@/store/comparisonSlice';
import './ComparisonBar.scss';

export const ComparisonBar = () => {
  const dispatch = useDispatch();
  const selectedIds = useSelector((state) => state.comparison.selectedIds);
  const count = selectedIds.length;

  if (!count) return null;

  const compareUrl = `/compare?ids=${encodeURIComponent(selectedIds.join(','))}`;
  return (
    <aside className="comparison-bar" aria-label="Property comparison">
      <div className="comparison-bar__content">
        <div className="comparison-bar__summary" aria-live="polite">
          <span className="comparison-bar__icon"><Scale size={19} aria-hidden="true" /></span>
          <span><strong>{count} of {MAX_COMPARISON_LISTINGS}</strong> properties selected</span>
          <span className="comparison-bar__hint">Select up to three to compare Monthly Rates and features.</span>
        </div>
        <div className="comparison-bar__actions">
          <button type="button" className="comparison-bar__clear" onClick={() => dispatch(clearComparison())}>
            <X size={16} aria-hidden="true" /> Clear
          </button>
          {count >= 2 ? (
            <Link className="comparison-bar__compare" to={compareUrl}>Compare properties</Link>
          ) : (
            <span className="comparison-bar__compare comparison-bar__compare--disabled">Select one more</span>
          )}
        </div>
      </div>
    </aside>
  );
};